'use client';

import CautionOverview from '@/components/caution-overview';
import {
  CAUTION_THEORY_EXAM_CONTENT,
  CAUTION_THEORY_EXAM_TITLE,
  THEORY_EXAM_COMMON_LIST,
  THEORY_EXAM_LICENSE_LIST,
  THEORY_EXAM_SUMMARY,
} from '@/data/exam/exam.data';
import { useState } from 'react';
import ExamGuideList from '../components/exam-guide-list';
import ExamGuideSummary from '../components/exam-guide-summary';
import MobileLicenseCard from './components/mobile-license-card';
import TheoryTabButton from './components/theory-tab-button';
import WebLicenseTable from './components/web-license-table';

export default function Client() {
  const buttons: string[] = ['면허종별 차이점', '공통사항'];
  const [activeTab, setActiveTab] = useState<string>(buttons[0]);

  return (
    <>
      <section className="desktop:web-w desktop:mx-auto desktop:pb-30">
        <div className="desktop:h-20 desktop:mb-15 mb-5 flex h-[50px] w-full gap-2">
          {buttons.map((button, idx) => (
            <TheoryTabButton
              key={'button' + idx}
              onClick={() => setActiveTab(button)}
              title={button}
              selected={activeTab === button}
            />
          ))}
        </div>

        {/**면허종별 차이점 */}
        {activeTab === buttons[0] && (
          <>
            {/**웹 */}
            <div className="desktop:block hidden">
              <WebLicenseTable items={THEORY_EXAM_LICENSE_LIST} />
            </div>

            {/**모바일 */}
            <div className="desktop:hidden mb-10 flex flex-col gap-6">
              {THEORY_EXAM_LICENSE_LIST.sort(
                (a, b) => a.mobileSeq - b.mobileSeq,
              ).map((item, idx) => (
                <MobileLicenseCard key={item.licenseType + idx} item={item} />
              ))}
            </div>
          </>
        )}

        {/** 공통사항 */}
        {activeTab === buttons[1] && (
          <>
            <ExamGuideSummary items={THEORY_EXAM_SUMMARY} />
            <ExamGuideList items={THEORY_EXAM_COMMON_LIST} />
          </>
        )}
      </section>

      {/* 안내사항 섹션 */}
      <CautionOverview
        title={CAUTION_THEORY_EXAM_TITLE}
        content={CAUTION_THEORY_EXAM_CONTENT}
      />
    </>
  );
}
